export default [
  `
  var sum = function (a,b) {
    return a+b
  };
  `,
  `
  var dateNow = function () {
    var today = new Date();
    var dd = today.getDate();

    var mm = today.getMonth()+1; 
    var yyyy = today.getFullYear();
    if(dd<10) 
    {
      dd='0'+dd;
    } 

    if(mm<10) 
    {
        mm='0'+mm;
    } 
    return yyyy+'-'+mm+'-'+dd;
  };
  `,
  `
  var timeNow = function () {
    var today = new Date();
    var hh = today.getHours();

    var mm = today.getMinutes(); 
    if(hh<10) 
    {
      hh='0'+hh;
    } 

    if(mm<10) 
    {
        mm='0'+mm;
    } 
    return hh+':'+mm+':00';
  };
  `,
  `
  var elementIndex = function (offset) {
    if(!offset)
      offset = 0
    var idParts = element.id.split("_")
    if(idParts.length >= 2)
      return parseInt(idParts[idParts.length - (1 + offset)]) - 1;
    return -1;
  };  
  `,
  `
  var valueOrOther = function (value) {
    if(!value)
      return "";
    if(value.value == "Other")
      return value.otherValue;
    return value.value;
  }; 
  `,
  `
  var getLastOtherResult = function () {
    var localOtherResults = [...otherResults];
    localOtherResults.sort((oR1,oR2) => formatDateTimeMysql(oR1.effectiveDate).localeCompare(formatDateTimeMysql(oR2.effectiveDate)));
    return localOtherResults[localOtherResults.length - 1]
  }; 
  `,
  `
  var getPreviousOtherResult = function (maxDate) {
    var localOtherResults = [...otherResults];
    localOtherResults.sort((oR1,oR2) => formatDateTimeMysql(oR1.effectiveDate).localeCompare(formatDateTimeMysql(oR2.effectiveDate)));
    return localOtherResults.filter(oR => {
      return !maxDate || formatDateTimeMysql(oR.effectiveDate + 'Z') <= maxDate
    });
  }; 
  `,
  `var getPreviousReviews = function() {
    return getPreviousOtherResult(!document.new ? formatDateTimeMysql(document.effectiveDate + 'Z') : false).
      filter(oR => oR.parentDocumentId && (oR.results['SingleChoice1_'+(elementIndex(2) + 1)+'_'+(elementIndex(1) + 1)] || oR.results['DatePicker1_'+(elementIndex(2) + 1)+'_'+(elementIndex(1) + 1)] || oR.results['Textarea2_'+(elementIndex(2) + 1)+'_'+(elementIndex(1) + 1)])).
        map(oR => { 
          return { 
            progress: oR.results['SingleChoice1_'+(elementIndex(2) + 1)+'_'+(elementIndex(1) + 1)], 
            dateAchieved: formatDateOnly(oR.results['DatePicker1_'+(elementIndex(2) + 1)+'_'+(elementIndex(1) + 1)]), 
            details: oR.results['Textarea2_'+(elementIndex(2) + 1)+'_'+(elementIndex(1) + 1)] }; 
          }
        )
  }`,
  `
  var addDaysToDate = function (a,b) {     
    var res = new Date(b+"T00:00:00");
    res.setDate(res.getDate() + a);
    var dd = ("0" + res.getDate()).slice(-2);
    var mm = ("0" + (res.getMonth() + 1)).slice(-2)
    var yyyy = res.getFullYear()    
    var date= yyyy+'-'+mm+'-'+dd;
    return date;
  };
  `
];
